import { useQuery } from '@tanstack/react-query'

import { httpService } from '@/api/v1/http.service'
import { arrayOfOptions } from '@/utils/zod'

const useSchoolBreaksYearsOptions = () =>
  useQuery({
    queryKey: ['panelSchoolBreaksOptionsYearsList'],
    staleTime: 60 * 100,
    queryFn: async () => {
      const response =
        await httpService.panel.panelSchoolBreaksOptionsYearsList()
      return arrayOfOptions.parse(response.results)
    }
  })

export default useSchoolBreaksYearsOptions
